module.exports = __webpack_public_path__ + "img/italian-serie-a-34__dark.2a8bba8b.png";